export const getSearchInputWidth = (state) => state.searchInput.inputWidth;
